module.exports = __webpack_public_path__ + "static/media/Davos_Klosters_01.f0540ba6.png";